import "@/App.css";
import { ThemeProvider } from "next-themes";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/landing/Layout";
import Home from "@/pages/Home";
import Welcome from "@/pages/Welcome";
import JoinClinicOS from "@/pages/JoinClinicOS";
import Platform from "@/pages/Platform";
import Build from "@/pages/Build";
import Kai from "@/pages/Kai";
import IntegrationPage from "@/pages/IntegrationPage";
import AIWorkforce from "@/pages/AIWorkforce";
import Integrations from "@/pages/Integrations";
import WhyClinicFirst from "@/pages/WhyClinicFirst";
import BookDemo from "@/pages/BookDemo";
import ModulePage from "@/pages/ModulePage";
import DisciplinePage from "@/pages/DisciplinePage";
import Products from "@/pages/Products";
import Support from "@/pages/Support";
import ClinicPulse from "@/pages/ClinicPulse";
import KaiExperience from "@/pages/KaiExperience";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Security from "@/pages/Security";
import Status from "@/pages/Status";
import AccessShell from "@/access/AccessShell";
import AccessOverview from "@/access/AccessOverview";
import AccessLeads from "@/access/AccessLeads";
import AccessSubmissions from "@/access/AccessSubmissions";
import AccessPages from "@/access/AccessPages";
import AccessAnalytics from "@/access/AccessAnalytics";
import AccessSettings from "@/access/AccessSettings";
import { AccessThemeProvider } from "@/access/theme";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <div className="App min-h-screen bg-background text-foreground antialiased">
        <BrowserRouter>
          <Routes>
            {/* Admin (no public layout, no public theme) */}
            <Route path="/access" element={<AccessThemeProvider><AccessShell /></AccessThemeProvider>}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard"   element={<AccessOverview />} />
              <Route path="leads"       element={<AccessLeads />} />
              <Route path="submissions" element={<AccessSubmissions />} />
              <Route path="pages"       element={<AccessPages />} />
              <Route path="analytics"   element={<AccessAnalytics />} />
              <Route path="settings"    element={<AccessSettings />} />
            </Route>

            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/join-clinicos" element={<JoinClinicOS />} />
              <Route path="/platform" element={<Platform />} />
              <Route path="/build" element={<Build />} />
              <Route path="/kai" element={<Kai />} />
              <Route path="/integrations/:slug" element={<IntegrationPage />} />
              <Route path="/ai-workforce" element={<AIWorkforce />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/why-clinicfirst" element={<WhyClinicFirst />} />
              <Route path="/book-a-demo" element={<BookDemo />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ModulePage />} />
              <Route path="/disciplines/:slug" element={<DisciplinePage />} />
              <Route path="/support" element={<Support />} />
              <Route path="/contact" element={<Support />} />
              <Route path="/clinic-pulse" element={<ClinicPulse />} />
              <Route path="/juvonno/clinicpulse" element={<ClinicPulse />} />
              <Route path="/juvonno/clinic-pulse" element={<ClinicPulse />} />
              <Route path="/kai-experience" element={<KaiExperience />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/security" element={<Security />} />
              <Route path="/status" element={<Status />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
